define('ErrorModel',['underscore', 'backbone', 'jquery', 'ObjectModel', 'app', 'site_vars'],function(_,Backbone,$,ObjectModel,app, site_vars){

    // empeche le flood d'erreur
    var MAX_ERROR_COUNT = 50, // nombre maximum d'erreurs remontées à 50
        errorCount = 0;

    var ErrorModelPrototype =  {
        name:'ErrorModel',
        idAttribute:'id_error',
        route:'apiErrorModel',
        initialize:function(errorMessage,debug){

            var model = this,
                error = model.get('error'),
                stack = model.get('stack');
            model.set({
                location:window.location.href,
                userAgent:navigator.userAgent,
                device:app.deviceType()
            });

            if(stack && stack.stack){
                model.set('stack',stack.stack);
            }else{
                model.unset('stack');
            }
            if(debug){
                if(!model.get('debug')){
                    model.set('debug',debug);
                }
            }


            if(!error){
                error = 'Undefined Error';
                if(_.isString(errorMessage)){
                    error = errorMessage;
                }
                model.set('error',error);
            }

            if(window.newrelic){
                try{
                    var nrError = new Error(error);
                    var nrMessage = error;
                    if(error.name) nrError.name = error.name;
                    if(stack) nrMessage = +"\n"+stack;
                    if(debug) nrMessage += "\ndebug : \n"+JSON.stringify(debug,null,4);
                    nrError.message = nrMessage;
                    newrelic.noticeError(nrError);
                }catch(err){

                }
            }

            try{
                // error environnement informations
                var cart = app.getCart(),
                    customer = app.getCustomer(),
                    errorAttributes = {
                        date_customer:(new Date()).toString(),
                        webapps_code:site_vars.webapps_code,
                        errorCount:errorCount
                    };
                    if(cart && customer){
                        errorAttributes = _.defaults({
                            id_customer:app.getCustomer().get('id_customer'),
                            id_store:cart.get('id_store'),
                            id_cart:cart.get('id'),
                            now:cart.get('now'),
                            vae:cart.get('vae'),
                            order_date:cart.get('order_date'),
                            order_time:cart.get('order_time'),
                        });
                    }
                    model.set(errorAttributes);
            }catch(error){
            }
            if(errorCount<MAX_ERROR_COUNT) {
                model.save();
            }
            errorCount ++;
        }
    };

    var ErrorModel = ObjectModel
        .extend(ErrorModelPrototype);

    ErrorModel.getTrace = function(message){
        var err = new Error(), funcName = 'Undefined', stack = err.stack.split("\n"), errorType='JSAlertError', m;
        if(stack.length>2){
            stack.shift();
            stack.shift();
            stack.shift();
        }
        try {
            var regEx = /at [a-zA-Z0-9_\.]*\.([a-zA-Z0-9_]*)/i.exec(stack[0]),
                funcName = regEx ? regEx[1] : stack[0];
        }catch(exception){
            funcName = stack[0] || 'Undefined'
        }
        funcName = funcName.trim().replace(/^(at |@)/,'');
        stack = stack.join("\n");
        m =  message ? ''+message : errorType;
        try {
            app.tc_err($body.get(0), m, funcName);
        }catch(exception){

        }
        return {error: m, funcName: funcName, stack: {stack: stack}}
    };

    return ErrorModel;
});
